import { Injectable } from '@angular/core';
import {
  CreateProductMarketPlaceLisitngRequest,
  PaginatedProductMarketPlaceLisitngsResponse,
  ProductMarketPlaceLisitngResponse,
} from '../../../Models/productMarketPlaceLIstingModel';
import { environment } from 'src/app/environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ProductMarketPlaceLisitngApiServiceService {
  baseUrl: string = environment.listerApiBaseUrl;
  constructor(private http: HttpClient) { }

  getProductMarketPlaceListings(
    companyId: number,
    status: number,
    type: number,
    marketplace: number,
    PostingProfileId: number,
    pageNumber?: number,
    pageSize?: number,
    searchTerm?: string,
    sortCriteria?: string,

  ): Observable<PaginatedProductMarketPlaceLisitngsResponse> {
    let url = `${this.baseUrl}/ProductMarketplaceListings`;
    let params = new HttpParams().set('companyId', companyId);
    params = params.set('type', type)
    params = params.set('status', status)
    params = params.set('marketplace', marketplace)

    if (PostingProfileId > 0) {
      params = params.set('PostingProfileId', PostingProfileId);
    }

    if (pageNumber != null) {
      params = params.set('pageNumber', pageNumber);
    }

    if (pageSize != null) {
      params = params.set('pageSize', pageSize);
    }

    if (searchTerm?.trim()) {
      params = params.set('searchTerm', searchTerm.trim());
    }

    if (sortCriteria != null) {
      params = params.set('sortCriteria', sortCriteria);
    }
    return this.http.get<PaginatedProductMarketPlaceLisitngsResponse>(url, {
      params,
    });
  }

  getProductMarketPlaceListingById(id: number) {
    const url = `${this.baseUrl}/ProductMarketplaceListings/${id}`;
    return this.http.get<ProductMarketPlaceLisitngResponse>(url);
  }

  createProductMarketPlaceListing(
    data: CreateProductMarketPlaceLisitngRequest
  ) {
    const url = `${this.baseUrl}/ProductMarketplaceListings`;
    return this.http.post(url, data);
  }
}
